import { render } from "./BottomUpFormPopup.vue?vue&type=template&id=9c8f607c&scoped=true&ts=true"
import script from "./BottomUpFormPopup.vue?vue&type=script&lang=ts"
export * from "./BottomUpFormPopup.vue?vue&type=script&lang=ts"

import "./BottomUpFormPopup.vue?vue&type=style&index=0&id=9c8f607c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8f607c"]])

export default __exports__